import { render, staticRenderFns } from "./AuditBatchTargetDataModal.vue?vue&type=template&id=66135cbf&scoped=true&"
import script from "./AuditBatchTargetDataModal.vue?vue&type=script&lang=js&"
export * from "./AuditBatchTargetDataModal.vue?vue&type=script&lang=js&"
import style0 from "./AuditBatchTargetDataModal.vue?vue&type=style&index=0&id=66135cbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66135cbf",
  null
  
)

export default component.exports